import { axiosInstance } from './axiosConfig';

export const getContext = () => axiosInstance.get(`platform/feature_flags/context`).then((response) => response.data);

export const getTrackEventsContext = () =>
  axiosInstance.get(`platform/track_event/context`).then((response) => response.data);
